import { Component } from '@angular/core';

@Component({
  selector: 'app-i-valida-ant-2026-info-component',
  imports: [],
  templateUrl: './i-valida-ant-2026-info-component.html',
  styleUrl: './i-valida-ant-2026-info-component.scss'
})
export class IValidaAnt2026InfoComponent {

}
